/* eslint-disable import/prefer-default-export */
const MAIN = [
  {
    title: 'Лучшие предложения',
    slug: 'top',
    route: '/avto',
  },
  {
    title: 'Имиджевые машины',
    slug: 'lowPrice',
    route: '/avto/bu',
  },
];

const LOW_PRICE_ONLY = [
  {
    title: 'Лучшие предложения',
    slug: 'lowPrice',
    route: '/avto/bu',
  },
];

const SPECIAL = {
  MAIN,
  LOW_PRICE_ONLY,
};

export default SPECIAL;



// WEBPACK FOOTER //
// ./src/desktop/constants/special.js